import { createFeatureSelector } from '@ngrx/store';

export const menuFlowImagesState = createFeatureSelector<OLO.State, OLO.State.MenuFlowImage[]>('menuFlowImages');
